import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewChecked, AfterViewInit, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { DhlFormControl } from '../../models/dhl-form-control';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';

@Component({
    selector: 'app-form-field-dropdown-multiselect-v2',
    templateUrl: './form-field-dropdown-multiselect-v2.component.html',
    styleUrls: ['./form-field-dropdown-multiselect-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDropdownMultiselectV2Component implements OnInit, AfterViewChecked, AfterViewInit {

  constructor(private _eref: ElementRef, private appService: AppService) { }

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;
  @ViewChild('visibleFormControl',{static: true, read: ElementRef}) visibleFormControl: ElementRef;
  @ViewChild('visibleDropdownList',{static: true, read: ElementRef}) visibleDropdownList: ElementRef;
  @ViewChild('formControl',{static: true, read: ElementRef}) formControl: ElementRef;

  validationType: string = '';
  toggleList: boolean = false;
  fieldControl: any;

  multiSelectValues = [];
  userTimeout;

  ngOnInit() {
    this.fieldControl = this.frmGroup.get(this.configData.name);
    if (this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);
    if (this.configData['storeDataName'] && sessionStorage.getItem(this.configData['storeDataName'])) {
      let formData = JSON.parse(sessionStorage.getItem(this.configData['storeDataName']));
      if (Array.isArray(formData) && formData.length) {
        formData.forEach(d => {
          this.selectedOption(null, d, { 'checked': true });
        })
      }
    } else if (this.configData.defaultValue) {
      this.configData.defaultValue['checked'] = false;
      this.selectedOption(null, this.configData.defaultValue, { 'checked': true });
    }
  }

  ngAfterViewChecked(){
    if(this.toggleList) {
      this.visibleDropdownList.nativeElement.style.width = this.visibleFormControl.nativeElement.offsetWidth + 'px';
      this.positionSimpleDropdown();
    }
    if(typeof this.fieldControl.value === 'string') {
      let itemObj = this.configData.options.find((data)=>{
        if(data['value'] === this.fieldControl.value){
          return data['value'];
        }
      })
      if(itemObj){
        this.selectedOption(null, itemObj, true);
      }
    }
  }

  ngAfterViewInit(){
    this.toggleDisable(this.configData['disabled']);
    // setTimeout(()=>{
    //   this.visibleDropdownList.nativeElement.style.width = this.visibleFormControl.nativeElement.offsetWidth + 'px';
    // }, 1000);
  }

  clearAll() {
    this.multiSelectValues = [];
    this.configData.options = this.configData.options.map(d => {
      return {
        ...d,
        checked: false
      }
    });

    this.configData.options.forEach((d: any) => {
      this.selectedOption(null, d.value, { 'checked': false });
    });
  }

  toggleDisable(disabled){
    if (disabled === true) {
      // this.frmGroup.get(this.configData.name).disable();
      this.formControl.nativeElement.parentElement.classList.add('disabled');
    } else {
      // this.frmGroup.get(this.configData.name).enable();
      this.formControl.nativeElement.parentElement.classList.remove('disabled');
    }
  }

  toggleDropdownList(event){
    this.toggleList = !this.toggleList;
  }
  returnMultiSelectValue(){
    let filterValue: string = '';
    if(Array.isArray(this.fieldControl.value)){
      filterValue = this.fieldControl.value.map(a =>  ' ' + a.displayValue).toString();
    }
    if(filterValue.length <= 0 && this.configData.placeHolder){
      this.fieldControl.value = "";
    }
    return filterValue.length > 0 ? filterValue : 'Please Select...';
  }
  manageDropdownValues(data, checked){
    if(checked){
      // To show selected option, adding checked attribute in each option
      this.handleSelectedOption(data,checked);            

      // when Active order(or any other multi value order) selected then check if any option which is part of active order is already in list then de-select it
      let removalIndex = [];
      this.multiSelectValues.forEach((obj,idx)=>{

        delete obj['dataType']; //CP-7273
        delete data['dataType']; //CP-7273

        if(obj == data){
          removalIndex.push(idx);
        } else if(this.appService.compareTwoObj(obj, data) === true){
          removalIndex.push(idx);
        } else {
          data['selectedOption'].split(',').forEach(abc=>{
            if(obj['selectedOption'] === abc){
              removalIndex.push(idx);
            }
          })
        }
      })
      if(removalIndex.length === 1){
        this.multiSelectValues.splice(removalIndex[0], 1);
      } else{
        while(removalIndex.length) {
          this.multiSelectValues.splice(removalIndex.pop(), 1);
        }
      }
      removalIndex.length = 0;
    
      if(this.multiSelectValues.indexOf(data) === -1 && data.value){
        this.multiSelectValues.push(data);
      }
    }
    else{
      let index: number;
      // To find selected option object which can be add or remove from multiSelectValues list
      this.multiSelectValues.some((r, a)=>{
        if(r.value == data.value){
          index = a;
          return true;
        }
      });
      // To show selected option, adding checked attribute in each option
      this.handleSelectedOption(data,checked);
      // To remove de-selected value from the multiSelectValues list
      let removalIndex = [];
      this.multiSelectValues.forEach((obj,idx)=>{

        delete obj['dataType']; //CP-7273
        delete data['dataType']; //CP-7273

        if(obj == data){
          removalIndex.push(idx);
        } else if(this.appService.compareTwoObj(obj, data) === true){
          removalIndex.push(idx);
        } else {
          data['selectedOption'].split(',').forEach(abc=>{
            if(obj['selectedOption'] === abc){
              removalIndex.push(idx);
            }
          })
        }
      })
      if(removalIndex.length === 1){
        this.multiSelectValues.splice(removalIndex[0], 1);
      } else{
        while(removalIndex.length) {
          this.multiSelectValues.splice(removalIndex.pop(), 1);
        }
      }
      removalIndex.length = 0;

      let indx = [];
      // check if selected value is part of Active orders(or multi value order) or multi selected field
      this.multiSelectValues.forEach((v, i) => {
        // if(v['value'] == 'Active Orders' || v['value'] == 'Verifiable Orders' || v['selectedOption'].split(',').length > 1){
        if (v['selectedOption'].split(',').length > 1) {
          let multipleText = v['selectedOption'].split(',');
          multipleText.forEach(text => {

            // if(data['value'] == 'Active Orders' || data['value'] == 'Verifiable Orders' || data['selectedOption'].split(',').length>1){
            if (data['selectedOption'].split(',').length > 1) {
              let selectedData = data['selectedOption'].split(',');
              if (selectedData.includes(text)) {
                let obj = {
                  multipleText, i, data
                }
                indx.push(obj);
                // this.resetSelection(multipleText, i, data);
              }
            }
            else {
              if (text === data['selectedOption']) {
                let obj = {
                  multipleText, i, data
                }
                indx.push(obj);
                // this.resetSelection(multipleText, i, data);
              }
            }
          })
        }

        // When option All was previously selected and now any of the option get de-select, also to deselect multi value value if de-selected value is part of it.
        // It also adds multi value order and there sub orders when de-selcted order is not related to them        
        else if (v['value'] == 'All' && checked == false) {
          this.multiSelectValues.splice(index, 1);
          this.configData.options.forEach(opt => {
            // if (opt['checked'] === true && opt['value'] !== 'Active Orders' && opt['value'] !== 'Verifiable Orders') {
            if (opt['checked'] === true) {
              if (this.multiSelectValues.indexOf(opt) === -1 && (opt['selectedOption'].split(',').length <= 1)) {
                this.multiSelectValues.push(opt);
              }
              else if (this.multiSelectValues.indexOf(opt) === -1 && (opt['selectedOption'].split(',').length > 1)) {
                let multipleText = opt['selectedOption'].split(',');
                let flag = false;
                if (data['selectedOption'].split(',').length > 1) {
                  let selectedData = data['selectedOption'].split(',');
                  multipleText.forEach(text => {
                    if (!selectedData.includes(text)) {
                      flag = true;
                    }
                  })
                  if (flag) {
                    this.multiSelectValues.push(opt);
                  }
                }
                else {
                  if (!multipleText.includes(data['selectedOption'])) {
                    this.multiSelectValues.push(opt);
                  }
                }
              }
            }
          })
        }
      })

      if (indx.length > 0) {
        indx = indx.reverse();
        indx.forEach(obj => {
          this.resetSelection(obj.multipleText, obj.i, obj.data);
        })
      }
      // if(this.multiSelectValues.indexOf(data) !== -1){
      //   this.multiSelectValues.splice(index, 1);
      // }
    }
    this.fieldControl.setValue(this.multiSelectValues);
  }
  selectedOption(userEvent, option, checkbox){
    userEvent ? userEvent.stopPropagation(): '';
    clearTimeout(this.userTimeout);

    this.manageDropdownValues(option, checkbox.checked);
    this.fieldControl.markAsTouched();
    this.fieldControl.markAsDirty();

    if(userEvent){
      let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events)
      if(!event && userEvent && this.configData["enableFilterSaveButton"]){
        this.sendToSource({"actionType" : "ENABLE_SAVE"}, userEvent);
      }
    }
    
    this.userTimeout = setTimeout(()=>{
      if(this.configData['productType'] && (this.configData['productType'] === 'FILTER' || this.configData['productType'] === 'NEW_FILTER')){
        this.toggleList = false;
      }
      if (this.frmGroup.get(this.configData.name).valid && this.configData.events) {
        let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events);
        if (event) {
          if(this.configData['storeDataName']){
            sessionStorage.setItem(this.configData['storeDataName'], JSON.stringify(this.fieldControl.value));
          }
          this.sendToSource(event, userEvent);
          return;
        }
        else if(!event && userEvent && this.configData["enableFilterSaveButton"]){
          this.sendToSource({"actionType" : "ENABLE_SAVE"}, userEvent);
        }
      }
    }, 1000);
  }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }
  @HostListener('document:click', ['$event']) 
  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target))
      this.toggleList = false;
  }

  positionSimpleDropdown() {
    const { left, top } = this.visibleFormControl.nativeElement.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let elOffsetTop = top + scrollTop;
    let elOffsetLeft = left + scrollX;
    let elHeight = 150; //Height of dropdown list (visibleDropdownList)
    let elWidth = this.visibleFormControl.nativeElement.offsetWidth; //Width of Calendar (visibleDropdownList)

    if (window.innerHeight < elOffsetTop + elHeight) {
      this.visibleDropdownList.nativeElement.classList.add('ulta');
    } else {
      this.visibleDropdownList.nativeElement.classList.remove('ulta');
    }
    if (elOffsetLeft + elWidth > window.innerWidth) {
      this.visibleDropdownList.nativeElement.classList.add('pulta');
    } else {
      this.visibleDropdownList.nativeElement.classList.remove('pulta');
    }
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    this.frmGroup.get(this.configData.name).reset();
    this.frmGroup.get(this.configData.name).updateValueAndValidity();
  }

  /** Common Method to check event exist in template */
  checkEventExist(events): DhlFormControlEvent | null {
    let eventName = (this.configData['productType'] === 'FILTER' || this.configData['productType'] === 'NEW_FILTER') ? 'MULTISELECT_FILTER': 'SELECTED_VALUE';
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      //event = (event.length ? event[0] : null);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }
  sendToSource(event, userEvent ) {
    let refinedData = {};
    if(this.configData['productType'] && (this.configData['productType'] === 'FILTER' || this.configData['productType'] === 'NEW_FILTER')){
      refinedData['queryString'] = this.invokeFilterProcess();
    } else {
      refinedData['queryString'] = this.frmGroup.get(this.configData.name).value;
    }
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: refinedData
    }
    console.log(refinedData);
    eventData['userEvent'] = userEvent;

    if(event.actionType === "ENABLE_SAVE" && userEvent && this.configData["enableFilterSaveButton"]){
      this.appService._commonComponentSubjectFilter.next(eventData);
    }
    else{
      this.appService._commonComponentSubject.next(eventData);
    }    
  }
  
  invokeFilterProcess(){
    let queryParam = '';
    this.multiSelectValues.forEach(obj=> {
      if(obj['filterValue']){
        queryParam += '&' + obj['filterValue'];
      }
    })
    return queryParam;
  }
  handleSelectedOption(data,checked){
    this.configData.options.map(option=>{
      option['value'] === 'All' && checked === false ? option['checked'] = false : null;
      // option['value'] === 'Active Orders' && checked === false && option['selectedOption'].split(',').includes(data['selectedOption'])? option['checked']=false: null;
      // option['value'] === 'Verifiable Orders' && checked === false && option['selectedOption'].split(',').includes(data['selectedOption'])? option['checked']=false: null;

      if (option['selectedOption'].split(',').length > 1 && checked === false) {
        if (checked === false && data['selectedOption'].split(',').length > 1) {
          data['selectedOption'].split(',').forEach(text => {
            option['selectedOption'].split(',').includes(text) ? option['checked'] = false : null;
          })
        }
        else {
          option['selectedOption'].split(',').includes(data['selectedOption']) ? option['checked'] = false : null;
        }
      }

      if(option['value'] && option['value'] === data['value']){
        option['checked']=checked;
        //To handle All case where multiple selection needs to be shown
        if(option['selectedOption']=== 'None'){
          this.multiSelectValues.length = 0;
          this.configData.options.map(opt=>opt['checked']=checked);
        } 
        //To handle Active order case where multiple selection needs to be shown
        else if(option['displayValue'] !== option['selectedOption'] && option['selectedOption']){
          option['selectedOption'].split(',').forEach(text=>{
            this.configData.options.map(data=>{
              if(data['displayValue']===text){
                data['checked'] = checked;
              }
            })
          })
        }
      }
    });
  }

  // This method is specially to remove Active order and re-select all left option
  resetSelection(multipleText, removalIndex, currentOption){
    this.multiSelectValues.splice(removalIndex, 1);
    multipleText.forEach(text=>{
      this.configData.options.find(elem => {
        // if (elem['value'] === 'Active Orders' || elem['value'] === 'Verifiable Orders') {
        //   elem['checked'] = false;
        // }
        if (elem['displayValue'] === text && currentOption['selectedOption'] !== elem['selectedOption']) {
          if (currentOption['selectedOption'].split(',').length > 1) {
            if (!currentOption['selectedOption'].split(',').includes(text)) {
              if (this.multiSelectValues.indexOf(elem) === -1) {
                this.multiSelectValues.push(elem);
              }
            }
          }
          else {
            if (this.multiSelectValues.indexOf(elem) === -1) {
              this.multiSelectValues.push(elem);
            }
          }
        }
      })
    })
  }

  resetAllSelection(){
    this.frmGroup.get(this.configData.name).setValue("");
    this.multiSelectValues = [];
    this.fieldControl.setValue("");
    this.returnMultiSelectValue();
    this.configData.options.map(option => {
      option['checked'] = false;
    })
  }

  clearFieldValue() {
    this.resetAllSelection();
  }

  selectOnlyThisOption(userEvent, option, checkbox){
    userEvent ? userEvent.stopPropagation(): '';
    clearTimeout(this.userTimeout);

    this.multiSelectValues =[];
    this.fieldControl.markAsTouched();
    this.fieldControl.markAsDirty();
    this.multiSelectValues.push(option);
    if (this.configData?.events?.length === 0) {
      checkbox.checked = true;
      this.manageDropdownValues(option, checkbox.checked);
      this.toggleList = false;
    }
    this.configData.options.map(data=>{
      data['checked'] = false;
      if(data['displayValue']===option['displayValue']){
        data['checked'] = true;
      }
    })
    this.fieldControl.setValue(this.multiSelectValues); 

    if(userEvent){
      let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events)
      if(!event && userEvent && this.configData["enableFilterSaveButton"]){
        this.sendToSource({"actionType" : "ENABLE_SAVE"}, userEvent);
      }
    }

    this.userTimeout = setTimeout(()=>{
      this.toggleList = false;
      if (this.frmGroup.get(this.configData.name).valid && this.configData.events) {
        let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events);
        if (event) {
          if(this.configData['storeDataName']){
            sessionStorage.setItem(this.configData['storeDataName'], JSON.stringify(this.fieldControl.value));
          }
          this.sendToSource(event, userEvent);
          return
        }
        else if(!event && userEvent && this.configData["enableFilterSaveButton"]){
          this.sendToSource({"actionType" : "ENABLE_SAVE"}, userEvent);
        }
      }
    }, 2200);
  }

  setValueToControl(options) {
    if (options != undefined) {
      options.forEach(option => {
        this.selectedOption(null, option, { 'checked': true });
      })
    }
  }
}